document.addEventListener('DOMContentLoaded', function () {
  initRolexMenu();
  initBannerSlider();
  initFeaturedProducts();
  initKeepExploring();
  initTabs();
  initPriceInfo();
  initSkipLinks();
  initGloboTabIndexObserver();
  initRolexKeyboardFocus();
  initRetailerToggle();
});

function initRolexMenu() {
  const toggleButton = document.querySelector('.rolex-menu-button');
  const mobileMenu = document.querySelector('.rolex-navigation-mobile-wrapper');
  const toggle_icon = document.querySelector('.rolex-menu-button');
  if (!toggleButton) return;
  if (!mobileMenu) return;
  if (!toggle_icon) return;

  toggleButton.addEventListener('click', function (e) {
    e.preventDefault();
    if (mobileMenu.hasAttribute('active')) {
      // Hide menu
      mobileMenu.removeAttribute('active');
      toggle_icon.removeAttribute('active');
    } else {
      // Show menu
      mobileMenu.setAttribute('active', '');
      toggle_icon.setAttribute('active', '');
    }
  });
}

function initBannerSlider() {
  const slider = document.querySelector('.rolex-banner-slider');
  if (!slider) return;

  const showArrows = slider.dataset.showArrows === 'true';
  const showPagination = slider.dataset.showPagination === 'true';

  new Splide(slider, {
    type: 'loop',
    perPage: 1,
    arrows: showArrows,
    pagination: showPagination,
    autoplay: false,
    interval: 5000,
    pauseOnHover: true,
  }).mount();
}

function initFeaturedProducts() {
  document.querySelectorAll('.rolex-featured-product-slider').forEach(function (slider) {
    if (slider.classList.contains('is-initialized')) return;

    var splide = new Splide(slider, {
      type: 'slide',
      perPage: 4,
      gap: '0px',
      arrows: true,
      pagination: true,
      accessibility: true,
      keyboard: 'global',
      slideFocus: false,
      drag: true,
      breakpoints: {
        1024: { perPage: 3 },
        767: { perPage: 2 },
      },
    });

    splide.mount();

    var selector = '#' + slider.id;
    disableSplideArrowsFocus(selector);
    disableSplidePaginationFocus(splide, selector);
    attachSplideKeyboardRoving(splide, selector, '.splide__slide .rolex-product-grid-inner');
  });
}

function initKeepExploring() {
  const selector = '#keep-exploring-splide';
  const slider = document.querySelector(selector);

  if (!slider) return;

  const showArrows = slider.dataset.showArrows === 'true';
  const showPagination = slider.dataset.showPagination === 'true';

  const splide = new Splide(slider, {
    type: 'slide',
    perPage: 4,
    gap: '8px',

    arrows: showArrows,
    pagination: showPagination,

    accessibility: true,
    keyboard: 'global',
    slideFocus: false,

    // Re-enable drag/swipe (mobile + tablet)
    drag: true,
    // swipe: true, // optional, true by default

    breakpoints: {
      1024: { perPage: 4 },
      768: { perPage: 3 },
      480: { perPage: 2 },
    },
  });

  splide.mount();

  // No attachSplideFocusHandler here

  disableSplideArrowsFocus(selector);
  disableSplidePaginationFocus(splide, selector);
  attachSplideKeyboardRoving(splide, selector, '.splide__slide .explore-item a');
}

function initTabs() {
  document.querySelectorAll('ul.r7-contact-tabs').forEach(function (tabList) {
    const links = tabList.querySelectorAll('a');

    let active = links[0];
    active.classList.add('r7-tab-active');

    let content = document.querySelector(active.getAttribute('href'));

    // Hide all except first
    links.forEach(function (link, index) {
      if (index !== 0) {
        const section = document.querySelector(link.getAttribute('href'));
        if (section) section.style.display = 'none';
      }
    });

    // Add click events
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();

        // Deactivate current
        if (active) active.classList.remove('r7-tab-active');
        if (content) content.style.display = 'none';

        // Activate new
        active = this;
        content = document.querySelector(active.getAttribute('href'));

        active.classList.add('r7-tab-active');
        if (content) content.style.display = 'block';
      });
    });
  });
}

function initPriceInfo() {
  const btn = document.getElementById('show-price-info');
  const infoArea = document.querySelector('.inf-area');

  if (btn && infoArea) {
    btn.addEventListener('click', function () {
      infoArea.classList.toggle('active');
    });
  }
}

function initSkipLinks() {
  const links = document.querySelectorAll('.skip-links .skip-link');
  if (!links.length) return;

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      const targetId = this.getAttribute('data-target');
      if (!targetId) return;

      const target = document.getElementById(targetId);
      if (!target) return;

      // --- Smooth scroll ---
      try {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      } catch (e) {
        // Fallback
        target.scrollIntoView(true);
      }

      // --- Move keyboard focus for accessibility ---
      setTimeout(function () {
        const hadTabindex = target.hasAttribute('tabindex');

        if (!hadTabindex) {
          // Make it temporarily focusable
          target.setAttribute('tabindex', '-1');
        }

        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          // Older browsers
          target.focus();
        }

        // Clean up if we added tabindex
        if (!hadTabindex) {
          setTimeout(() => target.removeAttribute('tabindex'), 800);
        }
      }, 300);
    });
  });
}

function initGloboTabIndexObserver() {
  function applyTabIndex() {
    const elements = document.querySelectorAll(
      '.globo-paragraph, .globo-heading, .heading-caption, .rpo-form_location > label.globo-label',
    );

    elements.forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
  }
  applyTabIndex();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function () {
      applyTabIndex();
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function initRolexKeyboardFocus() {
  /*1) If .rolex-header is present inside #MainContent, add "has-rolex" */
  const mainContent = document.getElementById('MainContent');
  if (mainContent && mainContent.querySelector('.rolex-header')) {
    mainContent.classList.add('has-rolex');
  }

  /* 2) If #MainContent has class "has-rolex", enable keyboard-only behavior
          - Pressing TAB will add class "keyfocus" on #MainContent
          - Any mouse click will remove class "keyfocus" */

  if (!mainContent || !mainContent.classList.contains('has-rolex')) return;

  // Add keyfocus when user presses Tab (keyboard navigation)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      mainContent.classList.add('keyfocus');
    }
  });

  // Remove keyfocus on mouse interaction
  document.addEventListener('mousedown', function () {
    mainContent.classList.remove('keyfocus');
  });
}

function initRetailerToggle() {
  const retailerList = document.getElementById('retailer-list');
  const toggleBtn = document.querySelector('.toggle-retailer');
  const toggleText = document.querySelector('.toggle-retailer-text');

  if (!retailerList || !toggleBtn || !toggleText) return;

  const originalText = toggleText.textContent;

  toggleBtn.addEventListener('click', function () {
    retailerList.classList.toggle('active');

    if (retailerList.classList.contains('active')) {
      toggleText.textContent = 'Map';
    } else {
      toggleText.textContent = originalText;
    }
  });
}

// Arrows not focusable
function disableSplideArrowsFocus(selector) {
  const root = document.querySelector(selector);
  if (!root) return;

  const arrows = root.querySelectorAll('.splide__arrow');
  arrows.forEach((arrow) => {
    arrow.setAttribute('tabindex', '-1');
  });
}

// Dots not focusable
function disableSplidePaginationFocus(splideInstance, selector) {
  const root = document.querySelector(selector);
  if (!root) return;

  const setPaginationTabIndex = function () {
    const dots = root.querySelectorAll('.splide__pagination__page');
    dots.forEach((dot) => {
      dot.setAttribute('tabindex', '-1');
    });
  };

  setPaginationTabIndex();
  splideInstance.on('moved', setPaginationTabIndex);
}

// Roving tabindex across all slide links
function attachSplideKeyboardRoving(splideInstance, selector, linkSelector) {
  const root = document.querySelector(selector);
  if (!root) return;
  const links = Array.prototype.slice.call(root.querySelectorAll(linkSelector));

  if (!links.length) return;

  links.forEach((link) => {
    link.setAttribute('data-splide-no-drag', 'true');
  });

  function setActiveLink(index) {
    links.forEach((link) => link.setAttribute('tabindex', '-1'));
    if (links[index]) {
      links[index].setAttribute('tabindex', '0');
    }
  }

  let initialIndex = 0;

  const activeSlideLink = root.querySelector('.splide__slide.is-active ' + linkSelector);

  if (activeSlideLink) {
    const idx = links.indexOf(activeSlideLink);
    if (idx !== -1) {
      initialIndex = idx;
    }
  }

  setActiveLink(initialIndex);

  splideInstance.on('moved', function (newIndex) {
    setActiveLink(newIndex);
  });

  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;

    const current = document.activeElement;
    const currentIndex = links.indexOf(current);

    if (currentIndex === -1) return;
    if (event.shiftKey) {
      if (currentIndex === 0) {
        setActiveLink(0);
        return;
      }

      event.preventDefault();
      const prevIndex = currentIndex - 1;
      setActiveLink(prevIndex);
      splideInstance.go(prevIndex);
      links[prevIndex].focus();
    } else {
      if (currentIndex === links.length - 1) {
        setActiveLink(currentIndex);
        return;
      }
      event.preventDefault();
      const nextIndex = currentIndex + 1;
      setActiveLink(nextIndex);
      splideInstance.go(nextIndex);
      links[nextIndex].focus();
    }
  });
}

document.addEventListener('keydown', function (e) {
  const label = e.target.closest('.gfb__radio-label.globo-option');

  if (!label) return;

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    label.click();
  }
});

// Accordion form script for Rolex product page
document.addEventListener('DOMContentLoaded', () => {
  const accordionItems = document.querySelectorAll('.rolex_accordion-item');
  const SCROLL_OFFSET = 80;

  if (!accordionItems.length) return;

  const updateHeight = (content) => {
    if (!content) return;
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  };

  const setupDynamicSizing = (item, content) => {
    if (content._cleanup) content._cleanup();
    const cleanups = [];

    // MutationObserver for dynamic content
    const mo = new MutationObserver(() => {
      if (item.classList.contains('active')) updateHeight(content);
    });
    mo.observe(content, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'data-step'],
    });
    cleanups.push(() => mo.disconnect());

    // Image load handling
    content.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        const onLoad = () => {
          if (item.classList.contains('active')) updateHeight(content);
        };
        img.addEventListener('load', onLoad);
        cleanups.push(() => img.removeEventListener('load', onLoad));
      }
    });

    // ResizeObserver for responsive content
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        if (item.classList.contains('active')) updateHeight(content);
      });
      ro.observe(content);
      cleanups.push(() => ro.disconnect());
    }

    // iframe handling
    content.querySelectorAll('iframe').forEach((f) => {
      const onLoad = () => updateHeight(content);
      f.addEventListener('load', onLoad);
      cleanups.push(() => f.removeEventListener('load', onLoad));
    });

    content._cleanup = () => {
      cleanups.forEach((fn) => fn());
      content._cleanup = null;
    };
  };

  const openItem = (item, content, { scroll = true, delay = false } = {}) => {
    item.classList.add('active');
    item.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'true');

    if (delay) {
      requestAnimationFrame(() => setTimeout(() => updateHeight(content), 250));
    } else {
      updateHeight(content);
    }

    setupDynamicSizing(item, content);

    if (scroll) {
      const rect = item.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: rect.top + scrollTop - SCROLL_OFFSET,
        behavior: 'smooth',
      });
    }
  };

  const closeItem = (item, content) => {
    item.classList.remove('active');
    item.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'false');
    if (content._cleanup) content._cleanup();
    content.style.maxHeight = '0px';
  };

  //  open first item by default
  const firstItem = accordionItems[0];
  if (firstItem) {
    const firstContent = firstItem.querySelector('.rolex_accordion-content');
    firstItem.classList.add('active');
    firstItem.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'true');
    updateHeight(firstContent);
    setupDynamicSizing(firstItem, firstContent);
  }

  // Toggle behavior
  accordionItems.forEach((item) => {
    const header = item.querySelector('.accordion-header');
    const content = item.querySelector('.rolex_accordion-content');
    if (!header || !content) return;

    // Accessibility
    header.setAttribute('aria-expanded', item.classList.contains('active') ? 'true' : 'false');

    header.addEventListener('click', () => {
      if (item.classList.contains('active')) {
        closeItem(item, content);
      } else {
        openItem(item, content, { scroll: true });
      }
    });
  });

  // Window load safety
  window.addEventListener('load', () => {
    accordionItems.forEach((item) => {
      if (item.classList.contains('active')) {
        const content = item.querySelector('.rolex_accordion-content');
        if (content) updateHeight(content);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('.r7-item-card');

  const now = new Date();
  const currentDay = now.getDay(); // 0 = Sunday
  const currentTime = now.getHours() * 60 + now.getMinutes();

  const dayMap = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  // Smart Time Parser (AM/PM + 24h + auto-fix)
  function parseTime(timeStr) {
    if (!timeStr) return null;

    timeStr = timeStr.trim().toLowerCase();

    let isPM = timeStr.includes('pm');
    let isAM = timeStr.includes('am');

    timeStr = timeStr.replace(/am|pm/g, '').trim();

    let [hours, minutes] = timeStr.split(':').map(Number);

    if (isNaN(hours)) return null;
    if (!minutes) minutes = 0;

    // AM/PM handling
    if (isPM && hours < 12) hours += 12;
    if (isAM && hours === 12) hours = 0;

    return {
      minutes: hours * 60 + minutes,
      hasAmPm: isAM || isPM,
    };
  }

  // Format 12h
  function format12h(minutes) {
    let h = Math.floor(minutes / 60);
    let m = minutes % 60;

    let ampm = h >= 12 ? 'pm' : 'am';

    h = h % 12;
    if (h === 0) h = 12;

    return `${h}:${m.toString().padStart(2, '0')}${ampm}`;
  }

  cards.forEach((card) => {
    const weeklyData = card.dataset.weekly;
    if (!weeklyData) return;

    let schedule;

    try {
      schedule = JSON.parse(weeklyData);
    } catch (e) {
      console.error('Invalid JSON timing', e);
      return;
    }

    const todayKey = dayMap[currentDay];
    const todayTiming = schedule[todayKey];

    const statusEl = card.querySelector('.status-text');
    const timeEl = card.querySelector('.time-range');

    // ❌ Closed
    if (!todayTiming || todayTiming.toLowerCase() === 'closed') {
      if (statusEl) {
        statusEl.textContent = 'Currently Closed';
        statusEl.classList.remove('open', 'closed');
        statusEl.classList.add('closed');
      }
      if (timeEl) timeEl.textContent = 'Closed';
      return;
    }

    const [openStr, closeStr] = todayTiming.split('-');

    const openObj = parseTime(openStr);
    const closeObj = parseTime(closeStr);

    if (!openObj || !closeObj) return;

    let openMinutes = openObj.minutes;
    let closeMinutes = closeObj.minutes;

    const hasAmPm = openObj.hasAmPm || closeObj.hasAmPm;

    // FIX: agar AM/PM missing hai aur close < open
    if (!hasAmPm && closeMinutes < openMinutes) {
      closeMinutes += 12 * 60; // assume PM
    }

    let isOpen;

    // Overnight case (real one like 10 PM - 2 AM)
    if (closeMinutes < openMinutes) {
      isOpen = currentTime >= openMinutes || currentTime < closeMinutes;
    } else {
      // Exact close time fix
      isOpen = currentTime >= openMinutes && currentTime < closeMinutes;
    }

    // Status
    if (statusEl) {
      statusEl.textContent = isOpen ? 'Currently Open' : 'Currently Closed';
      statusEl.classList.remove('open', 'closed');
      statusEl.classList.add(isOpen ? 'open' : 'closed');
    }

    // Display always AM/PM
    if (timeEl) {
      timeEl.textContent = `${format12h(openMinutes)} - ${format12h(closeMinutes)}`;
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.guarantee-accordion .accordion-item');

  // Always open the first accordion by default
  if (accordionItems.length > 0) {
    const firstItem = accordionItems[0];
    const firstContent = firstItem.querySelector('.content');

    firstItem.classList.add('item-open');
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
  }

  // Setup toggle for each item
  accordionItems.forEach((item) => {
    const header = item.querySelector('h3');
    const content = item.querySelector('.content');

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('item-open');

      // Close all items
      accordionItems.forEach((i) => {
        i.classList.remove('item-open');
        i.querySelector('.content').style.maxHeight = null;
      });

      // If it was NOT open, then open it
      if (!isOpen) {
        item.classList.add('item-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });

    // Keyboard support
    header.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        header.click();
      }
    });
  });

  // function updateConsentLinks() {
  //   document.querySelectorAll('.bespoke-form-holder div.globo-form-control[data-type="consent"] .checkbox-wrapper .checkbox-label p a')
  //     .forEach(function(link) {
  //       link.target = '_self';
  //       link.removeAttribute('rel');
  //     });
  // }

  // updateConsentLinks();

  // const observer = new MutationObserver(updateConsentLinks);

  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });
});

document.addEventListener('keydown', function (e) {
  const gridBox = e.target.closest('.grid-box');

  if (!gridBox) return;

  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();

    const link = gridBox.querySelector('a[href]');
    if (link) {
      link.click();
    }
  }
});
